import { HttpClient } from '../../httpClient'
import type { OpalApi, OpalApiResponseDocument } from '../../schema'

type UpdateContentV2 = OpalApi<'UpdateContentV2', 202>
type ResponseData = OpalApiResponseDocument<'UpdateContentV2', 202>

/**
 * The only endpoint that takes an absolute schedule for a piece of content.
 * `/content/v3` carries no writable date, and `/content_schedules/v3` states
 * the schedule as an offset from the parent moment, so a caller that only knows
 * the day a person dropped something on would have to work the offset out.
 *
 * The id is the content's `legacy_id`, not its UUID.
 */
export const updateContent: UpdateContentV2 = async ({
  params,
  requestBody,
}: Parameters<UpdateContentV2>[0] = {}) => {
  const contentId = params?.path?.content_id
  if (!contentId) {
    throw new Error('content_id is a required path parameter')
  }

  const url = new URL(`/content/v2/${contentId}`, window.location.origin)

  return HttpClient()
    .patch<ResponseData>(url.toString(), requestBody)
    .then((res) => res.data)
}
